(() => {
  const popup = document.querySelector('[data-membership-popup]');
  if (!popup || popup.dataset.initialized === 'true') return;
  popup.dataset.initialized = 'true';

  const key = 'evig-flora-membership-popup-dismissed';
  const closeButtons = popup.querySelectorAll('[data-popup-close]');
  const dialog = popup.querySelector('[role="dialog"]');
  const firstInput = popup.querySelector('input[type="email"]');
  let lastFocused;

  const close = () => {
    popup.hidden = true;
    document.body.classList.remove('membership-popup-open');
    const days = Number(popup.dataset.storageDays || 7);
    localStorage.setItem(key, String(Date.now() + days * 86400000));
    lastFocused?.focus?.();
  };

  const cartIsEmpty = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return false;
      const cart = await response.json();
      return Number(cart.item_count || 0) === 0;
    } catch (_) {
      return false;
    }
  };

  const open = async () => {
    if (!(await cartIsEmpty())) return;
    lastFocused = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('membership-popup-open');
    window.setTimeout(() => (firstInput || popup.querySelector('[data-popup-close]'))?.focus(), 50);
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (popup.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])')].filter((element) => !element.disabled);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  if (popup.querySelector('[data-popup-success]')) {
    localStorage.removeItem(key);
    open();
    return;
  }

  let dismissedUntil = 0;
  try { dismissedUntil = Number(localStorage.getItem(key) || 0); } catch (_) {}
  if (dismissedUntil > Date.now() && !Shopify.designMode) return;
  window.setTimeout(() => void open(), Number(popup.dataset.delay || 10000));
})();
